const CAS_PREFERRED_LANGUAGE = 'CAS_PREFERRED_LANGUAGE'

const setCookie = (name, value = '', domain = '.creditreform.de') => {
    /**
     * Entferne die Domain-Einstellung, damit es auf dem lokalen Rechner funktioniert.
     *  document.cookie = name + "=" + (value || "") + expires + "; path=/";
     */
    document.cookie = `${name}=${value}; SameSite=None; Secure;domain=${domain};path=/`
}

const getCookie = name => {
    if (document.cookie.indexOf(name) !== -1) {
        const cookieValue = document.cookie.split(`${name}=`)[1].split(';')[0]
        return cookieValue === 'undefined' || cookieValue === '' ? null : cookieValue
    }
    return null
}

const getCASPreferredLanguageCookie = () => getCookie(CAS_PREFERRED_LANGUAGE)

const setCASPreferredLanguageCookie = (value, domain = '.creditreform.de') => setCookie(CAS_PREFERRED_LANGUAGE, value, domain)

export { getCASPreferredLanguageCookie, setCASPreferredLanguageCookie }
